var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"pa-6"},[_c('Header'),_c('v-main',{staticClass:"content"},[_c('Sidebar'),_c('router-view'),_c('TheSideview'),_c('TheModal'),_c('TheSecondModal'),_c('TheSnackbar'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }